import React, { useState } from 'react';
import Locales from 'locales';
import { renderCGUContent } from 'helpers';
import { LegalAccordionPage, LegalAccordionRow } from 'components/shared/LegalAccordionPage';

const Cgu = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleBlock = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <LegalAccordionPage title={Locales.cgu.title}>
      {Locales.cgu.articles.map((article) => (
        <LegalAccordionRow
          key={article.id}
          id={`legal-section-${article.id}`}
          title={article.article}
          isOpen={openIndex === article.id}
          onToggle={() => toggleBlock(article.id)}
        >
          {renderCGUContent(article.content, `cgu-${article.id}`)}
        </LegalAccordionRow>
      ))}
    </LegalAccordionPage>
  );
};

export default Cgu;
